import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Row, Col } from 'antd'
import util from '../../util/util'
import '../../css/patient.scss'
import { useHistory } from 'react-router'
import _, { upperFirst } from 'lodash'
import { constants } from '../../constants'

const FilterList = (props) => {
  const isadmin =
    props.currentUserRole == constants.ROLE.ADMIN ||
    props.currentUserRole == constants.ROLE.SURGEON ||
    false

  return props.filters && Object.keys(props.filters).length == 0 ? (
    <Row style={{ height: '100%' }} gutter={'10'}>
      <Col style={{ alignSelf: 'center' }} span={4}>
        {'No filters applied.'}
      </Col>
    </Row>
  ) : (
    <>
      {!isadmin && (
        <Row hidden={!props.filters?.customerIds?.length} gutter={'10'}>
          <Col style={{ fontWeight: 'bold' }} span={4}>
            {'Clinics'}
          </Col>
          <Col span={20}>
            {props.filters?.customerIds?.map((e, i) => {
              console.log('JJL', _.find(props.customers, { id: e }))
              return (
                <span key={i + 1}>
                  {i == 0 ? ':' : ','}{' '}
                  {_.find(props.customers, { id: e })?.name}
                </span>
              )
            })}
          </Col>
        </Row>
      )}
      <Row hidden={!props.filters?.healthCoachIds?.length} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Healthcoach'}
        </Col>
        <Col span={8}>
          {props.filters?.healthCoachIds?.map((e, i) => {
            return (
              <Row>: {util.getObj(props.healthCoachList, e)?.firstname}</Row>
            )
          })}
        </Col>
      </Row>
      {/* <Row hidden={!props.filters?.firstname} gutter={"10"}>
                <Col style={{fontWeight: "bold"}} span={4}>{"First Name"}</Col> 
                <Col span={8}>: {props.filters?.firstname}</Col>
            </Row>
            <Row hidden={!props.filters?.lastname} gutter={"10"}>
                <Col style={{fontWeight: "bold"}} span={4}>{"Lastname Name"}</Col> 
                <Col span={8}>: {props.filters?.lastname}</Col>
            </Row> */}
      <Row hidden={!props.filters?.caseNumbers?.length} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Case numbers'}
        </Col>
        <Col span={8}>
          :
          {props.filters?.caseNumbers?.map((e, i) => {
            if (i < 7) return i == 6 ? e + '' : e + ','
            else if (i == 7) return '...'
            else return ''
          })}
        </Col>
      </Row>
      <Row hidden={!props.filters?.patientName} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Last Name'}
        </Col>
        <Col span={8}>:&nbsp;{props.filters?.patientName}</Col>
      </Row>
      <Row hidden={!props.filters?.last4DigitsOfPhone} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Phone (last 4)'}
        </Col>
        <Col span={8}>:&nbsp;{props.filters?.last4DigitsOfPhone}</Col>
      </Row>
      <Row hidden={!props.filters?.type} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
         Patient Type
        </Col>
        <Col span={8}>:&nbsp;
        {props.filters?.type?upperFirst(props.filters?.type):props.filters?.type}
        </Col>
      </Row>
      <Row hidden={!props.filters?.priorities?.length} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Priorities'}
        </Col>
        <Col span={8}>
          :&nbsp;
          {props.filters?.priorities?.map((e, i) =>
            i == props.filters?.priorities?.length - 1 ? e + '' : e + ','
          )}
        </Col>
      </Row>
      <Row hidden={!props.filters?.status?.length} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Status'}
        </Col>
        <Col span={8}>
          :&nbsp;
          {props.filters?.status?.map((e, i) =>
            i == props.filters?.status?.length - 1 ? e + '' : e + ','
          )}
        </Col>
      </Row>
      <Row hidden={!props.filters?.titles?.length} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Types'}
        </Col>
        <Col span={8}>
          :&nbsp;
          {props.filters?.titles?.map((e, i) =>
            i == props.filters?.titles?.length - 1 ? e + '' : e + ','
          )}
        </Col>
      </Row>
      <Row hidden={!props.filters?.updatedAtRange} gutter={'10'}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Updated range'}
        </Col>
        <Col span={8}>
          :&nbsp;
          {props.filters?.updatedAtRange
            ? props.filters?.updatedAtRange[0] +
              '-' +
              props.filters?.updatedAtRange[1]
            : null}
        </Col>
      </Row>
      <Row gutter={'10'} hidden={isadmin}>
        <Col style={{ fontWeight: 'bold' }} span={4}>
          {'Total'}
        </Col>
        <Col span={8}>:&nbsp;{props.total}</Col>
      </Row>
    </>
  )
}

FilterList.propTypes = {
  customer: PropTypes.object,
  filters: PropTypes.object,
  surgeon: PropTypes.array,
}

const mapStateToProps = (state) => {
  return {
    currentUserRole: state.profile.user.role,
    companyId: state.profile.company?._id,
    isLoading: state.actioncase.isLoading,
    customers: state.customer.customers,
    filters: state.actioncase.filters,
    healthCoachList: state.actioncase.healthCoachList,
    total: state.actioncase.total,
  }
}

export default connect(mapStateToProps, null)(FilterList)
